import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import Backdrop from '@mui/material/Backdrop';

import Slide from '@mui/material/Slide';

import Bs4MainDispatch from './Bs4MainDispatch';
import { SESSION_EXPIRED_MESSAGE } from './Bs4MainWindow';

import Bs4I18N from './Bs4I18N';
import {toTime, toTimeNoTimezone} from './Bs4Components/Bs4Utils'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props}/>;
});

export default function Bs4SessionExpired(props) {      
  const theme = useTheme();
  const [time, setTime] = React.useState(new Date())

  React.useEffect(() => {    
    const startTime = new Date();
    let lastTime = new Date() - startTime;
    let lastTimeStr = toTimeNoTimezone(lastTime)
    setTime(lastTimeStr);
    const intervalID = setInterval(() => {
      lastTime = new Date() - startTime;
      const newTimeStr = toTimeNoTimezone(lastTime);
      if (newTimeStr != lastTimeStr && props.sessionExpired) {
        document.title = login+' '+newTimeStr;
        setTime(newTimeStr)
      }
      lastTimeStr = newTimeStr;
    }, 333) 

    return () => {
      clearInterval(intervalID)
      document.title = props.documentTitle;
    }
  }, [props.sessionExpired])

  const imgTop = props.loginType === 'ebok' ? 'logineboklogo' : 'loginlogo';
  const imgLeft = props.loginType === 'ebok' ? 'loginebokscreen' : 'loginscreen';
  
  const linkTop = Bs4MainDispatch.getUrlPath(`showp.php?${imgTop}`);
  const linkLeft = Bs4MainDispatch.getUrlPath(`showp.php?${imgLeft}`);

  const login = window.localStorage.getItem(SESSION_EXPIRED_MESSAGE);

  if (!props.sessionExpired || props.smallScreen) return null;

  
  
  const handleCkick = (event) => {
    //props.setSessionExpired(false);
    //  console.log('...Bs4SessionExpired..click.', props)
  }

  //console.log('...Bs4SessionExpired...', login, time)

  return (
    <Backdrop 
        //open={props.sessionExpired}
        open
        sx={{backgroundColor: 'transparent', zIndex: (theme) => theme.zIndex.modal + 10}}        
    >        
      <Box 
        height='100%' 
        width='100%'
        onClick={handleCkick}        
        display='flex' 
        flexDirection='column' 
        justifyContent='center' 
        alignItems='center' 
        p={0}
      >
        <img src={linkLeft} style={{width:'100%', height:'100%', objectFit:'cover', objectPosition: 'center'}}/>
        <Stack direction="column" justifyContent="center" alignItems="center" spacing={2} sx={{position:'absolute', left: 0, top: 0, width: '100%', height: '100%'}}>
          <Typography variant='h4' sx={{color: '#ffffff', textShadow: '1px 1px 2px black, 0 0 25px gray, 0 0 5px gray'}}  >{login}</Typography>
          <Typography variant='h1' sx={{color: '#ffffff', textShadow: '1px 1px 2px black, 0 0 25px gray, 0 0 5px gray'}}  >{time}</Typography>
        </Stack>

        <Stack direction="column" justifyContent="center" alignItems="center" spacing={1} sx={{position:'absolute', right: 0, top: 0, }}>
          {/* <IconButton 
            onClick={handleCkick} 
            sx={{color: '#ffffff', textShadow: '1px 1px 2px black, 0 0 25px gray, 0 0 5px gray'}}
          >
            <CloseIcon/>
          </IconButton> */}
        </Stack>
      </Box>
    </Backdrop>
  )
}
